import "./App.css";
import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { Wrapper } from "./styled";
import DefaultRoute from "../../commons/DefaultRoute";
import GenerateCoupon from "../GenerateCoupon";
import StartForm from "../StartForm";
import GeneratePaymentRequest from "../GeneratePaymentRequest";
import { GlobalStyle } from "../../../styles/globalStyle";
import { PATH_COUPON, PATH_DETAIL, PATH_FORM, PATH_REQUEST } from "./constants";
import PaymentDetail from "../PaymentDetail";

const App = () => {
  return (
    <Wrapper>
      <BrowserRouter>
        <Switch>
          <Route exact path={PATH_COUPON} component={GenerateCoupon} />
          <Route exact path={PATH_FORM} component={StartForm} />
          <Route exact path={PATH_REQUEST} component={GeneratePaymentRequest} />
          <Route exact path={PATH_DETAIL} component={PaymentDetail} />
          <DefaultRoute />
        </Switch>
        <GlobalStyle />
      </BrowserRouter>
    </Wrapper>
  );
};

export default App;
